// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { ThemeProvider, createTheme, Box, Toolbar } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StatusBar from "./components/StatusBar";
import Dashboard from "./pages/Dashboard";
import MyBids from "./pages/MyBids";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AdminDashboard from "./pages/AdminDashboard";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import TrikotDetail from "./pages/TrikotDetail";
import './utils/axiosConfig';
import Info from "./pages/Info";

const theme = createTheme({
  palette: {
    primary: {
      main: "#23255d", // Dragons-Blau
    },
    secondary: {
      main: "#fbc917", // Dragons-Gelb
    },
  },
});

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              minHeight: "100vh",
            }}
          >
            <Header />
            <Toolbar /> {/* Spacer for fixed header */}
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: 2,
                width: "100%",
                pb: 6, // Padding bottom für die fixe Statuszeile
              }}
            >
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/info" element={<Info />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute adminOnly={true}>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/my-bids"
                  element={
                    <ProtectedRoute>
                      <MyBids />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/trikot/:id"
                  element={
                    <ProtectedRoute>
                      <TrikotDetail />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Box>
            <Footer />
            <StatusBar />
          </Box>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
